var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-plp",
      class: { "--is-in-search": _vm.isInsideSearchPanel },
    },
    [
      _c("rb-plp-wishlist-modal", {
        attrs: { show: _vm.showWishlistModal },
        on: {
          "wishlist-added": _vm.handleWishlistModal,
          close: _vm.closeWishlistModal,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rb-plp-header" },
        [
          !_vm.searchTerm
            ? [
                _vm.canShowBreadcrumbs
                  ? _c("rb-breadcrumbs", {
                      attrs: { breadcrumbs: _vm.parsedBreadcrumbs },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$slots["hero-banner"]
                  ? _c(
                      "div",
                      { staticClass: "rb-plp__hero-banner" },
                      [_vm._t("hero-banner")],
                      2
                    )
                  : _c(
                      "div",
                      { staticClass: "rb-plp-header__block m-dynamic--x" },
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "rb-plp-header__title",
                            class: { "--no-m": !_vm.subtitle },
                          },
                          [_c("html-fragment", { attrs: { html: _vm.title } })],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isMobile && !_vm.isPlpExclusive
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "rb-plp-header__title-number-of-products",
                              },
                              [
                                _vm._v(
                                  "(" + _vm._s(_vm.totalNumberOfProducts) + ")"
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", { staticClass: "rb-plp-header__subtitle" }, [
                          _vm._v(_vm._s(_vm.subtitle)),
                        ]),
                      ]
                    ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots["crosslinks"]
            ? _c(
                "rb-crosslinks-wrapper",
                { staticClass: "m-dynamic--x" },
                [_vm._t("crosslinks")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("rb-facets-panel", {
            attrs: {
              facets: _vm.mappedFacets,
              "panel-is-open": _vm.panelIsOpen,
              "total-products": _vm.totalNumberOfProducts,
              "applied-facets": _vm.appliedFacets,
              "min-price-range": _vm.minPriceRange,
              "max-price-range": _vm.maxPriceRange,
              "reset-facet-price": _vm.resetFacetPrice,
              "disabled-close-button": _vm.disabledButtonFacetPanel,
            },
            on: { closed: _vm.closedPanel, reset: _vm.removeAllFacets },
          }),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isPlpExclusive
        ? _c(
            "div",
            {
              ref: "filtersElements",
              staticClass: "rb-plp-header__actions",
              class: {
                "--no-gap": _vm.isMobile && !_vm.hasPromoPanel,
              },
            },
            [
              _c(
                "div",
                { staticClass: "rb-plp-header__actions-left" },
                [
                  _c("rb-facets-cta", {
                    attrs: {
                      facets: _vm.mappedFacets,
                      "total-products": _vm.appliedFacets.length,
                    },
                    on: { openPanel: _vm.togglePanelFacets },
                  }),
                  _vm._v(" "),
                  !_vm.isMobile && _vm.hasPromoPanel
                    ? _c("rb-promo-toggles", {
                        attrs: {
                          "first-toggle": _vm.firstToggle,
                          "applied-facets": _vm.appliedFacets,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c("rb-sort-by", {
                        attrs: {
                          "sort-options": _vm.sortOptions,
                          "applied-sort-by": _vm.appliedSortBy,
                        },
                        on: { changed: _vm.setSortOption },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rb-plp-header__actions-right" },
                [
                  !_vm.isMobile
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "rb-plp-header__total-number-of-products",
                          },
                          [
                            !_vm.totalNumberOfProducts && !_vm.isNoResults
                              ? _c("rb-dummy-skeleton", {
                                  staticClass: "--skeleton",
                                })
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.totalNumberOfProducts) +
                                      " " +
                                      _vm._s(_vm.$t("plp.results")) +
                                      " "
                                  ),
                                ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("rb-sort-by", {
                          attrs: {
                            "sort-options": _vm.sortOptions,
                            "applied-sort-by": _vm.appliedSortBy,
                          },
                          on: { changed: _vm.setSortOption },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile && _vm.hasPromoPanel
                    ? _c("rb-promo-toggles", {
                        attrs: {
                          "first-toggle": _vm.firstToggle,
                          "applied-facets": _vm.appliedFacets,
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("main-page-after-description"),
      _vm._v(" "),
      _vm._t("crown-module"),
      _vm._v(" "),
      !_vm.products.length && !_vm.isNoResults
        ? _c(
            "div",
            {
              staticClass: "rb-products grid rb-products--skeleton",
              class: { "--plp-exclusive": _vm.isPlpExclusive },
            },
            _vm._l(6, function (i) {
              return _c("rb-product-tile", {
                key: i,
                class: _vm.productTileClass,
                attrs: {
                  "is-plp-exclusive": _vm.isPlpExclusive,
                  loading: true,
                  "is-editorial": false,
                  product: {},
                },
              })
            }),
            1
          )
        : _vm.products.length > 0
        ? [
            _c("rb-products", {
              ref: "products",
              class: { "--no-seo": !_vm.seoText && !_vm.isLoadMoreVisible },
              attrs: {
                "is-plp-exclusive": _vm.isPlpExclusive,
                products: _vm.products,
                "data-element-id": _vm.elementId,
                "applied-facets": _vm.appliedFacets,
                "is-inside-search-panel": _vm.isInsideSearchPanel,
              },
              on: { "wishlist-added": _vm.handleWishlistModal },
            }),
            _vm._v(" "),
            _vm.isLoadMoreVisible
              ? _c("rb-load-more", {
                  attrs: {
                    "total-number-of-products": _vm.totalNumberOfProducts,
                    products: _vm.products,
                    "data-element-id": _vm.readMoreElementId,
                  },
                  on: { loadMoreProducts: _vm.loadMoreProducts },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isNoResults && !_vm.isMobile ? _c("rb-no-results") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [_vm._t("dynamic-content")],
        2
      ),
      _vm._v(" "),
      _c("rb-seo-related-links"),
      _vm._v(" "),
      _vm.seoText
        ? _c("rb-seo-description", {
            attrs: {
              "hide-title": true,
              title: _vm.title,
              subtitle: _vm.seoText,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots["before-footer"] ? _vm._t("before-footer") : _vm._e(),
      _vm._v(" "),
      _vm.$slots["before-footer-two"] ? _vm._t("before-footer-two") : _vm._e(),
      _vm._v(" "),
      _c("modal-portal", { staticClass: "modal-wrapper--main" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }